import { Transform } from 'class-transformer';

export function StripComma() {
  return Transform(({ value }) => {
    if (typeof value === 'string') {
      return value.replace(/,/g, '');
    }
    return value;
  });
}
